import { render, staticRenderFns } from "./storage.vue?vue&type=template&id=2c2637b6&scoped=true&"
import script from "./storage.vue?vue&type=script&lang=ts&"
export * from "./storage.vue?vue&type=script&lang=ts&"
import style0 from "./storage.vue?vue&type=style&index=0&id=2c2637b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2637b6",
  null
  
)

export default component.exports